import { notification } from 'antd';
import { appApi } from 'services/api/api-instance';
import type { ListResponseWithPagination } from 'services/api/types';
import type { Organization, OrganizationsListRequest } from './types';

export const getOrganizationsList = (
  params: OrganizationsListRequest = {},
): Promise<ListResponseWithPagination<Organization>> => {
  return appApi
    .get('/organizations/with-municipality', {
      params,
      paramsSerializer: { indexes: null },
    })
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось загрузить организации' });
      throw error;
    });
};

export const getOrganizationById = (organizationId: number): Promise<Organization> => {
  return appApi
    .get(`/organizations/${organizationId}/with-municipality`)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось загрузить организацию' });
      throw error;
    });
};
